import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ScanRegionForm } from '../model';

@Component({
    selector: 'app-scan-regions-form',
    templateUrl: './scan-regions-form.component.html',
    styleUrl: './scan-regions-form.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ScanRegionsFormComponent {
    @Input()
    scanRegionControlsArray: FormArray<FormGroup<ScanRegionForm>>;

    @Input()
    modalities: string[];

    @Input()
    bodyParts: string[];

    onScanRegionChange() {
        this.refreshRowErrors();
    }

    deleteScanRegion(index: number) {
        if (this.scanRegionControlsArray.length == 0) {
            return;
        }

        this.scanRegionControlsArray.removeAt(index);
        this.scanRegionControlsArray.markAsDirty();
        this.refreshRowErrors();
    }

    deleteAllScanRegions() {
        this.scanRegionControlsArray.clear();
    }

    removeEmptyScanRegions() {
        if (this.scanRegionControlsArray.length == 0) {
            return;
        }

        const indicesToRemove: number[] = [];
        this.scanRegionControlsArray.controls.forEach((region, index) => {
            const modality = region.controls.modality.value;
            const bodyPart = region.controls.bodyPart.value;
            const phaseOfContrast = region.controls.phaseOfContrast.value;

            if (modality === '' && bodyPart === '' && phaseOfContrast === '') {
                indicesToRemove.push(index);
            }
        });

        indicesToRemove.reverse().forEach(index => {
            this.scanRegionControlsArray.removeAt(index);
        });

        this.scanRegionControlsArray.markAsDirty();
        this.refreshRowErrors();
    }

    refreshRowErrors() {
        this.scanRegionControlsArray.controls.forEach((scanRegionControls: FormGroup<ScanRegionForm>, rowIndex: number) => {
            const modalityControl = scanRegionControls.controls.modality;
            const bodyPartControl = scanRegionControls.controls.bodyPart;
            const phaseOfContrastControl = scanRegionControls.controls.phaseOfContrast;
            if (this.isScanRegionDuplicate(modalityControl.value, bodyPartControl.value, phaseOfContrastControl.value, rowIndex)) {
                phaseOfContrastControl.markAsTouched();
                phaseOfContrastControl.setErrors({ duplicatedStudy: true });
            } else {
                phaseOfContrastControl.updateValueAndValidity({ emitEvent: false });
            }
        });
    }

    /**
     * With given modality, bodyPart and phaseOfContrast values, check if there are any duplicate scan regions in the other rows
     */
    isScanRegionDuplicate(modalityValue: string, bodyPartValue: string, phaseOfContrastValue: string, rowIndex: number | null): boolean {
        return (
            this.scanRegionControlsArray.controls.filter(
                (child, index) =>
                    (rowIndex === null || index !== rowIndex) &&
                    modalityValue &&
                    child.value.modality === modalityValue &&
                    bodyPartValue &&
                    child.value.bodyPart === bodyPartValue &&
                    phaseOfContrastValue &&
                    child.value.phaseOfContrast === phaseOfContrastValue
            ).length > 0
        );
    }
}
